import { SET_SETTINGS } from "../actions/type";

export const updateSettings =
  ({
    distanceUnit,
    theme,
    language,
    showScale,
    noImage,
    rotationMode,
    sortNeighboursAlphabetically,
  }) =>
  (dispatch) => {
    dispatch({
      type: SET_SETTINGS,
      payload: {
        distanceUnit,
        theme,
        language,
        showScale,
        noImage,
        rotationMode,
        sortNeighboursAlphabetically,
      },
    });
  };
